import FormData from "csi/action/FormData";
import def from "csi/def";
import FieldConstructor from "csi/def/Field";
import { FormView } from "csi/form/View";
import NewFrom from "csi/table/NewFrom";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import _ from "underscore";
import ProductType from "../ProductType";

const NewFromColorPaletteWizard = declare([NewFrom, ActionControllerMixin], {

	idWizardResource: "NewFromColorPaletteWizard",
	PROPAGATE_FIELD: "3DPropagate3DMaterials",
	PRODUCT_SOURCE: "ProductSource",
	PRODUCT_SOURCES: "ProductSources",
	_fdPalette: null,
	_fdPage2: null,

	/**
	 * @override
	 * Disable finish button
	 */
	disableFinish: function (wizard, page, index) {
		return index == 0 || !(this.m_formData.getSelectedNodes().length > 0);
	},

	/**
	 * @override
	 * Disable next button if no selections
	 */
	disableNext: function (wizard, page, index) {
		return index == 0 && !(this._fdPalette.getSelectedNodes().length > 0);
	},

	/**
	 * @override
	 * Filter nodes based on the selected palette
	 */
	getWizardViewQuery: function (wizard, view, index) {
		const parent = this.getParent();
		const isStyle = parent.$Type === "Style";
		const query = new Query();
		if (index == 0 && isStyle) {
			ProductType.applyStyleHierarchyFilters(parent, query, this.getCache());
			return query;
		} else if (index == 1) {
			return query.RefAttr("__Parent__", xml.OP_EQUALS, this._fdPalette.getSelectedNode().$URL)
				.Attr(isStyle ? "OKForStyle" : "OKForMaterial", xml.OP_EQUALS, true);
		}
		return this.inherited(arguments);
	},

	/**
	 * @override
	 * Pass data into the next page
	 */
	onNextPage: function (wizard, currentPage, nextPage, bFinish) {
		let fd = this.m_formData;
		const indexOfPage = wizard.getIndexOfPage(nextPage);
		let bRefresh = false;
		if (indexOfPage == 0) {
			fd = this._fdPalette = this._fdPalette || new FormData(this);
			fd.m_bRequireOne = true;
			fd.m_bSelectOne = true;
		} else if (indexOfPage == 1) {
			const palette = wizard.getFormDataFromPage(currentPage)
				.getSelectedNode();

			// initialize form data
			fd = this._fdPage2 = this._fdPage2 || this.m_formData;
			if (fd.getNode() != palette) {
				fd.setNode(palette);
				fd.resetAggregations();
				fd.resetSelections();
				bRefresh = true;
			}
			fd.m_bRequireOne = true;
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregate);
		}

		return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
	},

	/**
	 * @override
	 * Add ColorwayAddToBom to the call
	 */
	toWriterRequest: function () {
		const call = this.inherited<CallMethod>(arguments);
		const addToBOM = this.m_formData.getFieldValue("ColorwayAddToBom");
		const propagate = this.m_formData.getFieldValue(this.PROPAGATE_FIELD) || false;
		const productSourceFieldValue = this.getParent().ColorAllocationStatus === "ColorAllocationStatus:Allocation WIP" ? this.m_formData.getFieldValue(this.PRODUCT_SOURCE, true) : null;
		call.addParameter("ColorwayAddToBom", xml.ATTR_BOOLEAN, addToBOM);
		call.addParameter(this.PROPAGATE_FIELD, xml.ATTR_BOOLEAN, propagate);
		call.addParameter(this.PRODUCT_SOURCES, xml.ATTR_REFLIST, productSourceFieldValue);
		return call;
	},

	/**
	 * @override
	 * Add checkbox field to form for adding new colorway to BOM
	 */
	_getFormView: function (node, bCheckOnly) {
		const defView = this.inherited<FormView>(arguments);
		if (defView && !bCheckOnly) {
			if (ProductType.hasTDS(this.getParent(), "ApparelBOM")) {
				defView.m_fields.push(lang.mixin(new FieldConstructor(), {
					m_label: "ColorwayAddToBom",
					m_typeControl: def.FIELD_CHECKBOX,
					bPersist: true,
				}));
			}
		}
		return defView;
	},

	/**
	 * @override
	 * Set default name for ColorSpec
	 */
	onCreatePopup: function (view) {
		this.inherited(arguments);

		const colorNode = this.getNode();
		if (colorNode) {
			view.defView.getFormData().setFieldInitialValue(xml.ATTR_NAME, colorNode.$Name);
			view.addFixedValue("ColorSpecification", colorNode.$URL);
			view.addFixedValue("ColorPalette", colorNode.__Parent__);
			view.bNewFrom = true;
		}
	},

	/**
	 * Return true if colorspec doesn't exist
	 * @param {Context} ctx
	 * @param {FormData} fd
	 * @return {boolean}
	 */
	_canAggregate: function (ctx, fd) {
		const parentNode = this.getParent();
		const colorSpec = parentNode && _.find(ctx.cache.getNodes(parentNode.ProductColors), (color) => {
			return ctx.getNodeURL() == color?.ColorSpecification;
		});

		return !colorSpec;
	},
});

export = NewFromColorPaletteWizard;

